export const SET_LOGIN_IN_PROGRESS = 'SET_LOGIN_IN_PROGRESS';
export const SET_SSO_ATTEMPTED = 'SET_SSO_ATTEMPTED';
export const SET_AUTO_LOGIN_COMPLETED = 'SET_AUTO_LOGIN_COMPLETED';
export const SET_LOGOUT_IN_PROGRESS = 'SET_LOGOUT_IN_PROGRESS';
export const ADD_AFTER_CREDENTIALS_LOGIN_HOOK = 'ADD_AFTER_CREDENTIALS_LOGIN_HOOK';
export const BEFORE_REGISTRATION_HOOK = 'BEFORE_REGISTRATION_HOOK';

export const setIsLoginInProcess = (inProcess) => ({
    type: SET_LOGIN_IN_PROGRESS,
    payload: inProcess
});

export const setSsoAttempted = () => ({
    type: SET_SSO_ATTEMPTED
});

export const setAutoLoginCompleted = () => ({
    type: SET_AUTO_LOGIN_COMPLETED
});

export const setIsLogoutInProcess = (inProcess) => ({
    type: SET_LOGOUT_IN_PROGRESS,
    payload: inProcess
});

export const addAfterCredentialsLoginHook = (hook) => ({
    type: ADD_AFTER_CREDENTIALS_LOGIN_HOOK,
    payload: hook
});

export const addBeforeRegistrationHook = (hook) => ({
    type: BEFORE_REGISTRATION_HOOK,
    payload: hook
});
